
import React from 'react';
import { Button } from '@/components/ui/button';
import { Copy } from 'lucide-react';
import { toast } from 'sonner';
import { cn } from '@/lib/utils';

interface ProfileWalletInfoProps {
  walletAddress?: string;
  registrationNumber?: number;
}

const ProfileWalletInfo: React.FC<ProfileWalletInfoProps> = ({ 
  walletAddress, 
  registrationNumber 
}) => {
  const copyToClipboard = () => {
    if (!walletAddress) return;
    
    navigator.clipboard.writeText(walletAddress)
      .then(() => toast.success('Wallet address copied to clipboard'))
      .catch(err => toast.error('Failed to copy wallet address'));
  };

  // Format the wallet address for display (truncate middle)
  const formatWalletAddress = (address: string) => {
    if (!address) return '';
    if (address.length <= 12) return address;
    
    return `${address.substring(0, 6)}...${address.substring(address.length - 4)}`;
  };

  return (
    <div className="space-y-1">
      {registrationNumber !== undefined && (
        <div className="flex items-center justify-center mb-2">
          <span className={cn(
            "bg-primary/10 px-3 py-1 rounded-full text-xs font-medium",
            "text-white/80"
          )}>
            User #{registrationNumber}
          </span>
        </div>
      )}

      {walletAddress && (
        <div className="flex items-center justify-center gap-2">
          <span className="text-sm text-white/60 font-mono">
            {formatWalletAddress(walletAddress)}
          </span>
          <Button 
            variant="ghost" 
            size="icon" 
            className="h-6 w-6 text-white/60 hover:text-white"
            onClick={copyToClipboard}
          >
            <Copy className="h-3.5 w-3.5" />
          </Button>
        </div>
      )}
    </div>
  );
};

export default ProfileWalletInfo;
